import React, {useEffect, useState} from 'react';
import Player from './Player/player';
import "./songItem.scss";

const SongItem = (props) => {
  const [titleDirection, setTitleDirection] = useState('rtl');
  const [subTitleDirection, setSubTitleDirection] = useState('rtl');

      useEffect(() => {
        if (/^[a-zA-Z -0-9]+$/.test(props.audio.author)) setTitleDirection('ltr') 
        else setTitleDirection('rtl');
        if (/^[a-zA-Z -0-9]+$/.test(props.audio.description)) setSubTitleDirection('ltr') 
        else setSubTitleDirection('rtl');
    },[])


    return (
      <div onClick={() => { props.onClickSong()}} className="song-item" style={{height: props.isDetailsFromLeft ? props.playerSize : null, display: props.isDetailsFromLeft ? "flex" : null }}>
        <Player audio={props.audio}  playerSize={props.playerSize} isDisplayPlayer={props.isDisplayPlayer}></Player>   
        <div className={`details ${props.isDetailsFromLeft ? 'details-left' : 'details-bottom'}`} style={{width: !props.isDetailsFromLeft ?  props.playerSize : null, height: props.isDetailsFromLeft ?  props.playerSize : null  }} >
          <div> 
            <div title={props.audio.description} className="song-name text" style={{direction: titleDirection }}>{props.audio.description}</div>
            <div title={props.audio.author} className="singer text" style={{direction: subTitleDirection }}>{props.audio.author}</div>
          </div>
        </div>     
      </div>
    
    ) ;
}
export default SongItem;


